import FetchIt from "./FetchIt"

const case_pagination = new FetchIt("/case/case_pagination")
const case_list = new FetchIt("/case/get-case-list/")


const Case = {
    getMany: ({ params, body }) => case_list.post({ params, body })
}

export default Case